<template>
  <div class="container">
    <content-header :data="[{text: '投票活动一览', path: '/vote/list'},{text: voteName+' 奖品管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
      </div>
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="奖品">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:102px;height:36px":src="scope.row.imageUrl" v-if="scope.row.imageUrl"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="level"
            label="等级">
          </el-table-column>
          <el-table-column
            prop="number"
            label="数量">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改奖品' : '添加奖品'" width="50%" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm">
            <el-form-item prop="prizeId" label="选择奖品" :label-width="formLabelWidth">
              <el-select v-model="curObj.prizeId" value-key="id" filterable placeholder="请选择"
              >
                <el-option
                  v-for="item in prizeOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="level" label="等级" :label-width="formLabelWidth">
              <el-select v-model="curObj.level" value-key="id" placeholder="请选择">
                <el-option
                  v-for="item in levelOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="number" label="数量" :label-width="formLabelWidth">
              <el-input v-model.number="curObj.number" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>

          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import VoteModel from 'models/vote'

  export default {
    data () {
      return {
        tableData: [],
        levelOpts: [{id: 1, name: '1等奖'}, {id: 2, name: '2等奖'}, {id: 3, name: '3等奖'}, {id: 4, name: '4等奖'}, {id: 5, name: '5等奖'}, {id: 6, name: '6等奖'}],
        voteId: '',
        voteName: '',
        curObj: {
          id: '',
          voteId: '',
          prizeId: '',
          level: 1,
          number: 1
        },
        curObjRules: {
          prizeId: [{ required: true, message: '请选择奖品', trigger: 'blur' }],
          level: [{ required: true, message: '请选择获奖等级', trigger: 'blur' }],
          number: [
            { required: true, message: '请输入数量', trigger: 'blur' },
            { type: 'number', message: '数量必须为数值' }
          ]
        },
        isObjShow: false,
        formLabelWidth: '80px',
        //
        prizeOpts: [],
      }
    },
    created () {
      this.voteId = this.$route.query.id
      this.voteName = this.$route.query.name
      this.getObjList()
      //
      VoteModel.findPrize({curPage: 1, pageSize: 1000, keywords: ''}).then(res => {
        this.prizeOpts = res.rows
      })
    },
    computed: {
    },
    methods: {
      getObjList () {
        VoteModel.findPrizeXref({voteId: this.voteId}).then(res => {
          this.tableData = res
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            VoteModel.deletePrizeXref({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          prizeId: '',
          voteId: '',
          level: 1,
          number: 1
        }
        this.isObjShow = true
      },
      newHandle () {
        VoteModel.createPrizeXref({
          prizeId: this.curObj.prizeId,
          voteId: this.voteId,
          level: this.curObj.level,
          number: this.curObj.number
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          prizeId: item.row.prizeId,
          voteId: this.voteId,
          level: item.row.level,
          number: item.row.number
        }
        this.isObjShow = true
      },
      editHandle () {
        VoteModel.updatePrizeXref({
          id: this.curObj.id,
          prizeId: this.curObj.prizeId,
          voteId: this.voteId,
          level: this.curObj.level,
          number: this.curObj.number
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
    .new-wrap
      .el-input
        width: 85%
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 180px
            height: 90px
            line-height: 90px
            text-align: center
          .avatar
            width: 180px
            height: 90px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/VotePrizeXref.vue